import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';

import i18n from './i18n.js';

import './registerServiceWorker'

import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faChevronRight,
    faChevronLeft,
    faSpinner,
    faCheck,
    faTimes,
    faThumbsUp,
    faThumbsDown,
    faClock,
    faHistory,
    faTrophy
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'


library.add(faHome, faChevronRight, faChevronLeft, faSpinner, faCheck, faTimes, faThumbsUp, faThumbsDown, faClock, faHistory, faTrophy)

Vue.component('font-awesome-icon', FontAwesomeIcon)

//Vue.config.productionTip = false

import {Icon} from 'leaflet'
import 'leaflet/dist/leaflet.css'


// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

var vm = new Vue({
    data: {
        loading: false,
        BPRoutes: [],
        BPPoints: [],
        solvedQuizes: [],
    },
    watch: {
        solvedQuizes: {
            handler() {
                //console.log('Quizdata changed!');
                localStorage.setItem('solvedQuizes', JSON.stringify(this.solvedQuizes));
            },
            deep: true,
        },
    },
    mounted() {
        if (localStorage.getItem('solvedQuizes')) {
            this.solvedQuizes = JSON.parse(localStorage.getItem('solvedQuizes'));
            //  this.$set()
        }

        this.loading = true;
        axios
            .get(process.env.VUE_APP_API_ENDPOINT + 'routen/list')
            .then(response => {
                //console.log(response.data);
                this.BPRoutes = response.data
            })
            .catch(error => {
                //console.log(error)
                this.errored = true
            })
            .finally(() => this.loading = false)
        axios
            .get(process.env.VUE_APP_API_ENDPOINT + 'punkte/list')
            .then(response => {
                //console.log(response.data);
                this.BPPoints = response.data
            })
            .catch(error => {
                //console.log(error)
                this.errored = true
            })
            .finally(() => this.loading = false)
    },
    i18n,
    router,
    render: h => h(App)
}).$mount('#app')
